__turbopack_context__.v({
  "container": "Tile-module__vfbEGG__container",
  "contentContainer": "Tile-module__vfbEGG__contentContainer",
  "headerContainer": "Tile-module__vfbEGG__headerContainer",
  "neutralBorderContainer": "Tile-module__vfbEGG__neutralBorderContainer",
  "transparentBorderContainer": "Tile-module__vfbEGG__transparentBorderContainer",
});
